import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { MODULES } from '@shared/constants';
import { PERMISSION_ACTIONS } from '@shared/constants';
import { getModulePermission } from '@shared/utils';

import { ModuleGuard } from '../core/guards/module.guard';
import { PermissionGuard } from '../core/guards/permission.guard';

import { AttendanceConfigurationComponent } from './attendance-configuration/attendance-configuration.component';
import { AttendanceComponent } from './attendance.component';

const routes: Routes = [
  {
    path: '',
    component: AttendanceComponent,
    canActivate: [ModuleGuard, PermissionGuard],
    data: {
      title: 'Attendance',
      goBackEnabled: true,
      searchBarEnabled: true,
    },
  },
  {
    path: 'attendance-configuration',
    component: AttendanceConfigurationComponent,
    canActivate: [ModuleGuard, PermissionGuard],
    data: {
      title: 'app.attendance.configuration',
      goBackEnabled: true,
      searchBarEnabled: false,
      module: MODULES.ATTENDANCE,
      allowedPermissions: getModulePermission(MODULES.ATTENDANCE, [
        PERMISSION_ACTIONS.WRITE,
      ]),
    },
  },
  {
    path: 'hr-bulk-upload',
    loadChildren: () =>
      import('./hr-bulk-upload/hr-bulk-upload.module').then(
        (m) => m.HrBulkUploadModule
      ),
  },
  {
    path: 'attendance-files',
    loadChildren: () =>
      import('./attendance-files/attendance-files.module').then(
        (m) => m.AttendanceFilesModule
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AttendanceRoutingModule {}
